import { useNavigate, useParams } from 'react-router-dom';
import { Button, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useSubmitRegistrationAsQuery } from '../../../registration/useRegistrationForm/useSubmitRegistration';
import {
  mapBeregningskjerneinput,
  transformBeregningskjerneInput
} from '../../../../components/registering/advisor/adjustParameters/utils';
import { AdjustParametersPage } from '../../../../components/registering/advisor/adjustParameters/adjustParametersPage';
import { useRegistrationSteps } from '../../hooks/useRegistrationSteps';
import { RegistrationCommonStep } from '../../../../utils/navigation';
import { ButtonWrapper } from '../solceller/form/components/styledComponents';
import { PageContentLoader } from '../../components/pageLoader';
import { ErrorBox } from '../../../../components/errorBox';

// This is a copy of the previous AdjustParameters component.
// This version displays all the values from beregningskjerneInput.
export const JusteringAvVerdier = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const { previousStep } = useRegistrationSteps(RegistrationCommonStep.PARAMETERS);

  // We submit a registration every time we mount this page.
  // In the future the data needs to be available when we arrive to this point.
  const {
    data: registrationData,
    loading,
    error,
    hasError,
    isFetchedAfterMount,
    refetch
  } = useSubmitRegistrationAsQuery(params.registrationId, 'adjustParameters');

  if (loading || !isFetchedAfterMount) {
    return <PageContentLoader />;
  }

  const beregningskjerneInput = registrationData?.energiplan?.energimerke?.inndata?.beregningskjerneInput;

  if (hasError || !beregningskjerneInput) {
    return (
      <>
        <ErrorBox error={error} registrationId={params.registrationId} />
        <ButtonWrapper>
          <Button variant="secondary" onClick={() => navigate(`../${previousStep}`)}>
            {t('form.common.previous')}
          </Button>
          {/* This page calculates on mount, so retry must explicitly rerun the failed request. */}
          <Button onClick={() => refetch()}>{t('generalError.retry')}</Button>
        </ButtonWrapper>
      </>
    );
  }
  const isDebugMode = window.config.VITE_DEBUG_MODE;
  const { defaultValues, parameters } = isDebugMode
    ? { defaultValues: mapBeregningskjerneinput(beregningskjerneInput), parameters: beregningskjerneInput }
    : transformBeregningskjerneInput(beregningskjerneInput);

  return (
    <>
      {isDebugMode && (
        <Paragraph style={{ backgroundColor: 'pink', padding: '10px' }}>
          Felt og kategorier markert med rosa er ikke synlig for brukere
        </Paragraph>
      )}
      <AdjustParametersPage
        registrationId={params.registrationId}
        beregningskjerneInput={beregningskjerneInput}
        defaultValues={defaultValues}
        parameters={parameters}
      />
    </>
  );
};
